import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation loginMutation($phone: String!, $pw: String!, $device_id: String) {
    User {
      login(phone: $phone, pw: $pw, device_id: $device_id) {
        token
        user {
          user_id
          points_balance
          has_daily_rentable
          phone
          email
          name
          img
          about
          chosen_user_type
          listings
          favs
          type
          paid
          rega_approved
          iam_verified
          show_aqar_plus
          active_aqar_plus_user
          create_time
          manager_id
          can_sov
        }
      }
    }
  }
`;

export const CREATE_PHONE = gql`
  mutation create($phone: String!) {
    User {
      create(phone: $phone) {
        user_id
        name
        phone
        img
        iam_verified
        listings
        favs
        type
      }
    }
  }
`;

export const FORGET_PASSWORD = gql`
  mutation forgetPassword($phone: String!) {
    User {
      forgetPassword(phone: $phone) {
        user_id
        name
        phone
        img
        iam_verified
        listings
        favs
        type
      }
    }
  }
`;

export const VERIFY = gql`
  mutation verify(
    $phone: String!
    $vcode: String!
    $pw: String!
    $public_token: String
    $device_id: String
  ) {
    User {
      verify(
        phone: $phone
        vcode: $vcode
        pw: $pw
        public_token: $public_token
        device_id: $device_id
      ) {
        token
        user {
          user_id
          name
          phone
          img
          email
          iam_verified
          listings
          favs
          type
          active_aqar_plus_user
        }
      }
    }
  }
`;
export const UPDATE_FORGET_PASSWORD = gql`
  mutation updateForgetPassword(
    $phone: String!
    $vcode: String!
    $pw: String!
    $device_id: String
  ) {
    User {
      updateForgetPassword(
        phone: $phone
        vcode: $vcode
        pw: $pw
        device_id: $device_id
      ) {
        token
        user {
          user_id
          name
          phone
          img
          email
          iam_verified
          listings
          favs
          type
          active_aqar_plus_user
        }
      }
    }
  }
`;

export const OTP_LOGIN = gql`
  mutation otpLoginMutation($pw: String!) {
    User {
      loginOTP(pw: $pw) {
        token
        user {
          user_id
          points_balance
          has_daily_rentable
          phone
          email
          name
          img
          about
          chosen_user_type
          listings
          favs
          type
          paid
          rega_approved
          iam_verified
          show_aqar_plus
          active_aqar_plus_user
          create_time
          manager_id
          can_sov
        }
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation {
    User {
      logout {
        user_id
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation update($data: UpdateUserDataInput!) {
    User {
      update(data: $data) {
        user_id
        name
        phone
        img
        email
        about
        chosen_user_type
        iam_verified
        listings
        type
        iban
        iban_bank
        vat_number
      }
    }
  }
`;

export const ADD_REGA_USER_ID = gql`
  mutation addREGAUserId($rega_user_id: String!) {
    User {
      addREGAUserId(rega_user_id: $rega_user_id)
    }
  }
`;

export const VERIFY_BML = gql`
  mutation verifyBMLLicense($url: String!) {
    User {
      verifyBMLLicense(url: $url)
    }
  }
`;
export const CHANGE_PHONE = gql`
  mutation changePhone($nphone: String!) {
    User {
      changePhone(nphone: $nphone) {
        user_id
        name
        phone
        img
        email
        iam_verified
        listings
        favs
        type
      }
    }
  }
`;

export const VERIFY_UPDATE_PHONE = gql`
  mutation updateChangePhone(
    $phone: String!
    $vcode: String!
    $device_id: String
  ) {
    User {
      updateChangePhone(phone: $phone, vcode: $vcode, device_id: $device_id) {
        token
        user {
          user_id
          name
          phone
          img
          email
          iam_verified
          listings
          favs
          type
          active_aqar_plus_user
        }
      }
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword(
    $phone: String!
    $pw: String!
    $npw: String!
    $device_id: String
  ) {
    User {
      changePassword(phone: $phone, pw: $pw, npw: $npw, device_id: $device_id) {
        token
        user {
          user_id
          name
          phone
          img
          email
          iam_verified
          listings
          favs
          type
          active_aqar_plus_user
        }
      }
    }
  }
`;

export const VERIFY_OFFICE = gql`
  mutation verifyOffice($file: String!, $cert_id: Float) {
    User {
      verifyOffice(file: $file, cert_id: $cert_id) {
        user_id
        name
        phone
        img
        email
        iam_verified
        listings
        favs
        type
      }
    }
  }
`;

export const CANCEL_MAIL_SUBSCRIPTION = gql`
  mutation cancelMailSubscription($token: String!, $email: String!) {
    User {
      cancelMailSubscription(token: $token, email: $email)
    }
  }
`;

export const ADD_TOURISM_PERMIT = gql`
  mutation addTourismPermit($listing_id: Int!, $file_name: String!) {
    DailyRenting {
      addTourismPermit(listing_id: $listing_id, file_name: $file_name)
    }
  }
`;
